export const REDIRECT_TO_KEY = 'returnTo';
export const SAML_LOGIN_URL = '/auth/sso/begin-login';
export const AUTH_LOGIN_URL = '/auth/login';
export const LOGOUT_URL = '/auth/logout';
// From /logout endpoint, we are re-directed to /login page. Now, if we want to go back to the same page after re-login, we need to set persistPath=true in the query params
// So, that backend can set "referer" in "returnTo" query param of login page.
export const LOGOUT_URL_WITH_PERSIST_PATH = '/auth/logout?persistPath=true';
// for private interfaces and session is anonymous(user is not created). it used by creating token using createExternalSession api
// eg belcorp chat, dda chatbot
export const AUTH_ENDPOINT_KEY = '/auth';
export const AUTH_KEY = '_at';
// client auth token cookie, used in matrix applications only
export const CLIENT_AUTH_KEY = '_cat';
export const ANONYMOUS_AUTH_KEY = '_aut';
// todo replace with cookie name after BE is ready
export const VALIDATE_AUTH_COOKIE = '_sts';

/* eslint-disable @typescript-eslint/naming-convention -- needed */
export enum HTTP_HEADERS {
  /**
   * Detect device of the user using useragent of nextjs
   */
  Device = 'x-ua-device',

  /**
   * Trace id for the request created by the client to be used for debugging purposes
   */
  TraceId = 'x-ua-trace-id',
  /**
   * Request id for the request created by the ui server to be used for debugging purposes
   */
  UIServerRequestId = 'x-ua-ui-req-id',
  /**
   * Timestamp of the request created by the client to be used for debugging purposes
   */
  Timestamp = 'x-ua-timestamp',

  /**
   * IANA timezone of the request runtime (e.g. 'Asia/Kolkata'), used by backend for tz-aware logic
   */
  Timezone = 'x-ua-timezone',

  /**
   * Project id of the request sent from the context for scoping
   */
  ProjectId = 'x-ua-project-id',

  /**
   * App id of the request sent from the context for scoping, used for integration purposes
   */
  AppId = 'x-ua-app',

  /**
   * Tenant domain of the request sent from the context for scoping, used for integration purposes
   */
  TenantDomain = 'x-ua-domain',

  /**
   * Tenant domain with URI for integration app on specific uri path at the tenant
   */
  TenantURI = 'x-ua-uri-prefix',

  /**
   * Locale of the user used from user api
   */
  Locale = 'x-ua-locale',

  /**
   * When the backend wants the user to update their password, they set this header in response to indicate to redirect to update password page
   */
  ExpiredPassword = 'x-ua-expired-password',

  /**
   * Is the interface public or private
   */
  PUBLIC = 'x-ua-public-interface',

  /**
   * Set by matrix proxy when the current page is a public page (/public/login, standard public pages, or custom public pages) within a private interface
   */
  IsPublicPage = 'x-ua-public-page',

  /**
   * Used for storing uppy upload bucket details
   */
  UppyUpload = 'x-ua-uppy-upload',
  /** Per-request signature (RFC 9449) proving the client still holds its session's key. */
  DPoP = 'DPoP',
  /**
   * Send auth token in the request header when third party cookies are not supported
   */
  AuthToken = 'x-ua-at',
  /**
   * Same as AuthToken, used in matrix applications only
   */
  ClientAuthToken = 'x-ua-cat',
  /**
   * Per-application auth token, minted when a code-builder app is created and stored
   * against its applicationId. Only apps running OUTSIDE deployment send it — the preview
   * and the local dev server, which have no end-user session of the app's own to
   * authenticate with. A deployed app is same-origin with the platform and uses the real
   * session, so its build never bakes the token in.
   */
  AppAuthToken = 'x-ua-app-auth-token',
  /**
   * Used for telling whether the request is for print preview
   */
  PrintPreviewKey = 'x-ua-print-preview',
  /**
   * Color scheme of the interface
   */
  ColorScheme = 'x-ua-color-scheme',
  /**
   * @deprecated
   * earlier we used to set color scheme (light/dark) in this header, now we use x-ua-color-scheme header
   */
  Theme = 'x-ua-theme',
  /**
   * Interface theme id (from theme manager) for the interface
   */
  InterfaceTheme = 'x-ua-interface-theme',
}

export const LOCALE_COOKIE_PREFIX = '_ua_locale';
export const COLOR_SCHEME_COOKIE_PREFIX = '_ua_color_scheme';
/**
 * @deprecated
 * earlier we used this prefix for color scheme cookie, now we use _ua_color_scheme prefix
 */
export const THEME_COOKIE_PREFIX = '_ua_theme';
export const INTERFACE_THEME_COOKIE_PREFIX = '_ua_interface_theme';
/** Resolved system color scheme (light/dark) set by client for server-side access when user preference is 'system' */
export const SYSTEM_COLOR_SCHEME_COOKIE = '_ua_system_color_scheme';
export const LOCALE_SEARCH_PARAMS_KEY = 'locale';
export const COLOR_SCHEME_SEARCH_PARAMS_KEY = 'colorScheme';
/**
 * @deprecated
 * earlier we used this search param for color scheme, now we use colorScheme search param
 */
export const THEME_SEARCH_PARAMS_KEY = 'theme';
export const INTERFACE_THEME_SEARCH_PARAMS_KEY = 'interfaceTheme';
export const CONTENT_TYPE_HEADER = 'Content-Type';

export const MFA_SESSION_COOKIE = 'ua_mfa';
